import React from "react";
import { nextScheduleAsString } from "./utils";
import ControlPanel from "./ControlPanel";
import ToggleIcon from "../../Components/ToggleIcon";
import { useSocketClient } from "../../contexts/SocketClientProvider";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import { IControlToggle } from "./types";
import { IconSets } from "./IconSets";

interface IControlToggleProps {
  control: IControlToggle;
}

const ControlToggle = (props: IControlToggleProps) => {
  const { control } = props;
  const status = useControlAttribute(control, "status");
  const nextSchedule = useControlAttribute(
    control,
    "next_schedule",
    control.next_schedule
  );
  const socketClient = useSocketClient();
  const iconName =
    status === "on"
      ? IconSets[control.icon_set_name].on
      : IconSets[control.icon_set_name].off;
  const mode: TMode = control.is_enabled ? status : "disabled";
  const iconColor = useModeColor(mode);
  const toggleStatus = () => {
    if (control.is_enabled) {
      socketClient.process_command({
        type: "control",
        id: control.id,
        command: "toggle",
        value: status === "on" ? "off" : "on",
      });
    }
  };

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      isToggle={true}
      state={nextScheduleAsString(nextSchedule)}
    >
      <ToggleIcon name={iconName} color={iconColor} onClick={toggleStatus} />
    </ControlPanel>
  );
};

export default ControlToggle;
